import { Box, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { IDataItem } from "src/types/atoms";
const DataItem = ({
  label,
  value
}: IDataItem) => {
  return <Box flexBasis={230} marginBottom={2}>
      <Typography color={grey[700]} fontWeight={700} marginBottom={1}>
        {label}
      </Typography>
      {typeof value === "string" ? <Typography color={grey[600]}>{value}</Typography> : value}
    </Box>;
};
export default DataItem;